<template>
    <div class="hts-menu-user">
        <div class="menu-top">
            <h1>
                {{ username ? username : '' }}
            </h1>
        </div>
        <div class="menu-body">
            <div
                v-if="isAdmin"
                class="menu-content">
                <div>
                    <!-- :to="{ name: 'admincp' }" -->
                    <div
                        class="block py-1 cursor-pointer"
                        @click="toAdminPage">
                        <p class="h-3 w-3 inline-block mr-2">
                            <span
                                v-if="isAdminRoute"
                                class="flex h-3 w-3">
                                <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-green-400 opacity-75" />
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500" />
                            </span>
                            <span
                                v-else
                                class="flex h-3 w-3">
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-500" />
                            </span>
                        </p>
                        <span>
                            System
                        </span>
                    </div>
                </div>
            </div>
            <div
                v-if="!isAdminRoute && isAdminCPManagement() && isWsVendor && isCompanyOwner"
                class="menu-content">
                <div>
                    <!-- hts-link :to="{ name: 'trucker-admin-id-admin' }" -->

                    <div
                        class="block py-1 cursor-pointer"
                        @click="toAdminCPPage">
                        <p class="h-3 w-3 inline-block mr-2">
                            <span
                                v-if="isCompanyAdminRoute"
                                class="flex h-3 w-3">
                                <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-green-400 opacity-75" />
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500" />
                            </span>
                            <span
                                v-else
                                class="flex h-3 w-3">
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-500" />
                            </span>
                        </p>
                        <span>
                            AdminCP
                        </span>
                    </div>
                </div>
            </div>
            <div
                v-if="workspaces?.length"
                class="menu-content">
                <h3>
                    {{ $t('menus.workspace') }}
                </h3>
                <div
                    v-for="(temWorkspace, index) in workspaces"
                    :key="index">
                    <div v-if="temWorkspace._sid">
                        <div
                            class="block py-1 cursor-pointer"
                            @click="(e) => toOwnerPage(e, temWorkspace)">
                            <p class="h-3 w-3 inline-block mr-2">
                                <span
                                    v-if="isCurrentWorkspace(temWorkspace)"
                                    class="flex h-3 w-3">
                                    <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-green-400 opacity-75" />
                                    <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500" />
                                </span>
                                <span
                                    v-else
                                    class="flex h-3 w-3">
                                    <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-500" />
                                </span>
                            </p>
                            <span>
                                {{ temWorkspace.name }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="companyType === 'PARTNER'"
                class="menu-content">
                <h3>
                    Client type
                </h3>
                <div
                    v-for="(cooperatorType, index) in cooperatorTypes"
                    :key="index">
                    <div
                        class="block py-1 cursor-pointer"
                        @click="(e) => toClientPage(e, cooperatorType)">
                        <p class="h-3 w-3 inline-block mr-2">
                            <span
                                v-if="isCurrentClientType(cooperatorType)"
                                class="flex h-3 w-3">
                                <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-green-400 opacity-75" />
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500" />
                            </span>
                            <span
                                v-else
                                class="flex h-3 w-3">
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-500" />
                            </span>
                        </p>
                        <span v-if="cooperatorType === 'PARTNER'">
                            Đội xe
                        </span>
                        <span v-if="cooperatorType === 'CUSTOMER'">
                            Khách hàng
                        </span>
                    </div>
                </div>
            </div>

            <div
                v-for="menu in CMenus"
                :key="menu.key"
                class="menu-content">
                <h3>
                    {{ $t(menu.name) || '' }}
                </h3>
                <div v-if="menu.type === 'active'">
                    <hts-link
                        v-for="item in $lodash.get(menu, 'items', [])"
                        v-show="checkPermission(('permissions' in item && item.permissions) || [], item.justOnePermission || false)"
                        :key="item.key"
                        :to="getRoute(item)"
                        class="block py-1">
                        item: {{ item }}
                        <p class="h-3 w-3 inline-block mr-2">
                            <span
                                v-if="'active' in item && item.active"
                                class="flex h-3 w-3">
                                <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-green-400 opacity-75" />
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500" />
                            </span>
                            <span
                                v-else
                                class="flex h-3 w-3">
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-500" />
                            </span>
                        </p>
                        <span>
                            {{ item.name }}
                        </span>
                    </hts-link>
                </div>
                <hts-link
                    v-for="item in $lodash.get(menu, 'items', [])"
                    v-else-if="menu.type === 'icon'"
                    v-show="checkPermission(('permissions' in item && item.permissions) || [], item.justOnePermission || false)"
                    :key="item.key"
                    :to="getRoute(item)"
                    class="flex items-center py-1">
                    <component
                        :is="$lodash.get(item, 'icon', '')"
                        class="w-5 h-5" />
                    <p class="pl-1">
                        {{ $t(item.name) }}
                    </p>
                </hts-link>
            </div>
        </div>
        <div class="menu-footer">
            <p
                class="cursor-pointer inline-block"
                @click="handleSignOut">
                <hi-arrow-right-on-rectangle-icon class="h-5 w-5 inline-block text-error-500" />
                <span class="pl-1">
                    Đăng xuất
                </span>
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'

import menusClient from '~/data/menus/customer/menuUser.json'
import partnerMenus from '~/data/menus/partner-portal/menuUser.json'
import admincpMenus from '~/data/menus/system/menuUser.json'
import menus from '~/data/menus/trucker/menuUser.json'
const companyTypes = computed((): string[] | undefined => store.userConfig.companyTypes)
const page = computed((): string => store.userConfig.getPage)
const workspaceType = computed((): string => store.auth.workspaceType)
const companyType = computed((): string => store.auth.companyType)

const isWsVendor = computed(() => workspaceType.value === 'VENDOR')
const isCompanyOwner = computed(() => companyType.value === 'OWNER')

const CMenus = computed<any[]>(() => {
  if (typePage?.value === 'user') {
    return []
  }
  if (workspaceType.value === 'IMPORT_AND_EXPORT') {
    return menusClient
  }

  if (workspaceType.value === 'VENDOR') {
    if (page.value === 'OWNER') {
      return menus
    }

    if (page.value === 'PARTNER') {
      return partnerMenus
    }
  }

  if (page.value === 'ADMINCP') {
    return admincpMenus
  }

  return []
})

const store = $store()
const { auth } = $store()
const props = defineProps({
  username: {
    type: String,
    default: ''
  },
  typePage: {
    type: String
  }
})

const { username, typePage } = toRefs(props)
const router = useRouter()
const route = useRoute()
const workspaces = computed(() => store.userConfig.workspaces)
const workspace: any = computed(() => store.system.workspace)
const cooperatorTypes = computed(() => store.auth.cooperatorTypes)
const workspaceId = computed(() => store.auth.workspaceId)
const workspaceSId = computed(() => workspace.value?._sid)
const isAdmin = computed(() => store.userConfig.isAdmin)
// const isCompanyAdmin = computed(() => store.userConfig.isCompanyAdmin)
const id = computed(() => router.currentRoute.value.params.id)
const routeName = computed(() => router.currentRoute.value.name)

const isAdminCPManagement = () => {
  return checkPermission(layoutPermissions.adminCP.admin_c_p_management)
}

const isCurrentWorkspace = (workspace: any) => {
  if (workspace._sid === workspaceSId.value) {
    return true
  }
  return false
}

const isCurrentClientType = (type: string) => {
  let prefit = ''

  if (type === 'PARTNER') {
    prefit = 'pp-id'
  }

  if (type === 'CUSTOMER') {
    prefit = 'pc-id'
  }

  if (routeName?.value?.toString().indexOf(prefit) === 0) {
    return true
  }

  return false
}

const isAdminRoute = computed(() => !id.value)

const isCompanyAdminRoute = computed(() => routeName?.value?.toString().startsWith('trucker-admin'))

const getRoute = (item: any): any => {
  if (!item.route) {
    return ''
  }
  if (!id.value) {
    return {
      ...item.route
    } as any
  }
  return {
    ...item.route,
    params: { id: id.value }
  } as any
}

const handleSignOut = $lodash.debounce(async () => {
  const api: {} = !isAdminRoute.value
    ? {
      url: '/auth/user/logout',
      method: 'post'
    }
    : {
      url: 'admincp/auth/logout',
      method: 'post'
    }

  const result = await $api(api)

  const data: any = $lodash.get(result, 'data.value')
  if (data.success) {
    if (process.client) {
      store.system.clear()
      store.auth.setWorkspaceId(null)
      store.auth.setAccessToken(null)
      $toast().success($t('notifications.logoutSuccess'))
      // return router.push({
      //   name: 'auth-login'
      // })
      location.href = '/auth/login'
    }
  }
}, 500)

const toAdminPage = (e: any) => {
  e.preventDefault()
  e.stopPropagation()
  store.auth.setWorkspaceId(null)
  nextTick(() => {
    location.href = '/admincp'
  })
  // router.push({ name: 'admincp' })
}

const toAdminCPPage = (e: any) => {
  e.preventDefault()
  e.stopPropagation()
  const workspaceId = auth.workspaceId

  nextTick(() => {
    location.href = `/trucker-admin-${workspaceId}/admin`
  })
}

const toOwnerPage = (e: any, workspace: any) => {
  e.preventDefault()
  e.stopPropagation()
  const { _sid, companyType, type, cooperatorTypes } = workspace
  auth.setWorkspace({ id: _sid, companyType, type, cooperatorTypes })

  route.meta.pageTabs = []

  if (type === 'VENDOR') {
    if (['OWNER'].includes(companyType)) {
      // return router.push({
      //   name: 'trucker-id-dashboard',
      //   params: { id: _sid }
      // })

      nextTick(() => {
        location.href = `/trucker-${_sid}/dashboard`
      })
    }
    if (['PARTNER'].includes(companyType)) {
      // return router.push({
      //   name: 'pp-id',
      //   params: { id: _sid }
      // })

      if (cooperatorTypes.includes('PARTNER')) {
        nextTick(() => {
          location.href = `/pp-${_sid}`
        })
      } else if (cooperatorTypes.includes('CUSTOMER')) {
        nextTick(() => {
          location.href = `/pc-${_sid}`
        })
      }
    }
  }

  if (type === 'IMPORT_AND_EXPORT') {
    if (['OWNER'].includes(companyType)) {
      // return router.push({
      //   name: 'trucker-id-dashboard',
      //   params: { id: _sid }
      // })

      nextTick(() => {
        location.href = `/c-${_sid}/dashboard`
      })
    }
  }
}

const toClientPage = (e: any, type: any) => {
  e.preventDefault()
  e.stopPropagation()

  route.meta.pageTabs = []

  if (type === 'PARTNER') {
    nextTick(() => {
      location.href = `/pp-${workspaceId.value}`
    })
  }

  if (type === 'CUSTOMER') {
    nextTick(() => {
      location.href = `/pc-${workspaceId.value}`
    })
  }
}
</script>
